export const Ajax_Url_Admin = '/api/mobilemode/admin';

export enum API_Modules {
  PICLIB = 'picLib',
};

export enum ViewAttr {
  Readonly = 1,
  Editable = 2
}

export const FOCUS_PLACEHOLDER = '::focus';

export default {};